(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gallery-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const params = new URLSearchParams(location.search);
      const piece = params.get('piece');
      const title = section.querySelector('[data-art-title]');
      if (title && /^[1-6]$/.test(piece || '')) {
        title.textContent = title.textContent.replace('title', piece.padStart(2, '0'));
        const reference = section.querySelector('[data-art-reference]');
        if (reference) reference.value = title.textContent;
      }
      const main = section.querySelector('[data-art-main]');
      section.querySelectorAll('[data-art-thumb]').forEach(button => {
        button.addEventListener('click', () => {
          const media = button.querySelector('.kag-thumb-media').cloneNode(true);
          const caption = button.lastElementChild.textContent;
          const image = media.querySelector('img');
          if (image) { image.sizes = '(min-width: 900px) 60vw, 100vw'; image.loading = 'eager'; }
          else { const label = document.createElement('span'); label.textContent = caption; media.append(label); }
          main.replaceChildren(media);
          section.querySelectorAll('[data-art-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
      const enlarge = section.querySelector('[data-art-enlarge]');
      const lightbox = section.querySelector('[data-art-lightbox]');
      if (enlarge && lightbox && typeof lightbox.showModal === 'function') {
        enlarge.hidden = false;
        const openImage = () => {
          const source = main.querySelector('img');
          if (!source) return;
          const image = source.cloneNode(true);
          image.sizes = '95vw';
          image.loading = 'eager';
          lightbox.querySelector('[data-art-expanded]').replaceChildren(image);
          lightbox.showModal();
        };
        enlarge.addEventListener('click', openImage);
        main.addEventListener('click', openImage);
        lightbox.querySelector('[data-art-close]').addEventListener('click', () => lightbox.close());
        lightbox.addEventListener('click', event => { if (event.target === lightbox) lightbox.close(); });
        lightbox.addEventListener('close', () => enlarge.focus({ preventScroll: true }));
      }
      const form = section.querySelector('#KickArtCustomInquiry');
      if (!form) return;
      const steps = [...form.querySelectorAll('[data-form-step]')];
      const controls = form.querySelector('[data-form-controls]');
      const progress = form.querySelector('[data-form-progress]');
      const next = form.querySelector('[data-form-next]');
      const back = form.querySelector('[data-form-back]');
      const type = form.querySelector('[data-project-type]');
      const purpose = form.querySelector('[data-purpose]');
      if (params.get('purpose') === 'business') purpose.value = 'Business or interior design project';
      const conditionals = () => {
        const chosen = type.value;
        const purposeValue = purpose.value;
        const active = { mural: chosen === 'Mural', portrait: chosen === 'Painting' || chosen === 'Drawing or illustration' || purposeValue === 'A gift', items: chosen === 'Custom sneakers' || chosen === 'Custom clothing or object', business: purposeValue === 'Business or interior design project' || purposeValue === 'Brand or event', event: chosen === 'Live event artwork' || purposeValue === 'Brand or event', collection: chosen === 'Coordinated collection' };
        form.querySelectorAll('[data-conditional]').forEach(group => { const enabled = active[group.dataset.conditional]; group.hidden = !enabled; group.querySelectorAll('input,select,textarea').forEach(input => input.disabled = !enabled); });
        form.querySelectorAll('[data-conditional-field]').forEach(input => { const enabled = active[input.dataset.conditionalField]; input.disabled = !enabled; input.closest('.kag-field').hidden = !enabled; });
      };
      type.addEventListener('change', conditionals);
      purpose.addEventListener('change', conditionals);
      conditionals();
      let current = 0;
      const show = (index, focus = true) => {
        current = index;
        steps.forEach((step, i) => step.hidden = i !== index);
        back.hidden = index === 0;
        next.hidden = index === steps.length - 1;
        progress.textContent = `${index + 1} / ${steps.length} · ${steps[index].querySelector('legend').textContent.trim().replace(/^\d+\s*/, '')}`;
        if (focus) { const heading = steps[index].querySelector('legend'); heading.tabIndex = -1; heading.focus(); }
      };
      next.addEventListener('click', () => {
        const invalid = [...steps[current].querySelectorAll('input,textarea,select')].find(input => !input.disabled && !input.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        show(Math.min(current + 1, steps.length - 1));
      });
      back.addEventListener('click', () => show(Math.max(current - 1, 0)));
      form.addEventListener('invalid', event => { const stepIndex = steps.findIndex(step => step.contains(event.target)); if (stepIndex >= 0 && stepIndex !== current) show(stepIndex, false); }, true);
      form.addEventListener('submit', event => { if (current < steps.length - 1) { event.preventDefault(); next.click(); } });
      if (form.querySelector('.errors')) {
        const errorStep = steps.findIndex(step => step.querySelector('[name="contact[email]"]'));
        current = Math.max(0, errorStep);
      }
      controls.hidden = false;
      progress.hidden = false;
      show(current, false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

